import React, { useEffect, useState } from "react";
import { Typography, Paper, TextField, Button, Switch, FormControlLabel } from "@mui/material";
import apiClient from "../../services/apiClient";
import SEO from "../../components/SEO";

export default function AdminSettingsPage() {
  const [settings, setSettings] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiClient.request("/api/admin/settings").then(setSettings);
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await apiClient.request("/api/admin/settings", {
        method: "PATCH",
        body: JSON.stringify(settings),
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <SEO title="Admin Settings | DigiBuddy" noIndex noFollow />
      <Typography variant="h4" sx={{ mb: 2 }}>Settings</Typography>
      <Paper sx={{ p: 2, display: "grid", gap: 1 }}>
        <FormControlLabel
          control={
            <Switch
              checked={Boolean(settings.sequence_enabled)}
              onChange={(e) => setSettings((s) => ({ ...s, sequence_enabled: e.target.checked }))}
            />
          }
          label="Sequence email active"
        />
        <FormControlLabel
          control={
            <Switch
              checked={Boolean(settings.calendly_enabled)}
              onChange={(e) => setSettings((s) => ({ ...s, calendly_enabled: e.target.checked }))}
            />
          }
          label="Module Calendly actif"
        />
        <TextField
          label="URL guide PDF"
          value={settings.guide_url || ""}
          onChange={(e) => setSettings((s) => ({ ...s, guide_url: e.target.value }))}
        />
        <TextField
          label="URL Calendly"
          value={settings.calendly_url || ""}
          onChange={(e) => setSettings((s) => ({ ...s, calendly_url: e.target.value }))}
        />
        <TextField
          label="Provider email"
          value={settings.email_provider || "console"}
          onChange={(e) => setSettings((s) => ({ ...s, email_provider: e.target.value }))}
          helperText="Valeurs possibles: console, smtp, brevo"
        />
        <TextField
          label="Email expediteur"
          value={settings.sender_email || ""}
          onChange={(e) => setSettings((s) => ({ ...s, sender_email: e.target.value }))}
        />
        <Button variant="contained" onClick={save} disabled={saving}>
          {saving ? "Sauvegarde..." : "Sauvegarder"}
        </Button>
      </Paper>
    </>
  );
}
